import * as Yup from 'yup';
import { CampaignData } from '../models/campaign.ts';
import { PurchaseInputData } from '../models/purchase.ts';

export type CampaignAsset = Pick<PurchaseInputData, 'authorName' | 'assetName' | 'assetLink' | 'releaseDate'>;

export type UpdateCampaignAssetDto = CampaignAsset & {
    campaignId: string,
};

// deno-lint-ignore no-namespace
export namespace UpdateCampaignAssetDto {
    export function createValidation(): Yup.ObjectSchema<UpdateCampaignAssetDto> {
        return Yup.object({
            campaignId: Yup.string().required('Product is required'),
            authorName : Yup.string().required('Artist name is required'),
            assetName: Yup.string().required('Song name is required'),
            assetLink: Yup.string().nullable().optional().url('Song link is invalid'),
            releaseDate: Yup.string().nullable().optional(),
        }).noUnknown();
    }
}

export type UpdateCampaignAssetResponseDto = {
    campaign: CampaignData;
};
